import { login } from '@/api/calls/auth';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { useAuthStatus, setAuthFlag } from './useAuthStatus';
import { errorToast } from '@/api/utils';

export const useLogin = () => {
  const { refetch: refetchAuthStatus } = useAuthStatus();

  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationFn: login,
    onSuccess: () => {
      setAuthFlag(); // Set flag that user has logged in
      refetchAuthStatus();
      navigate('/');
    },
    onError: (_error: Error) => {
      errorToast('Inloggning misslyckades');
    },
  });
  return {
    login: loginMutation.mutate,
    isLoading: loginMutation.isPending,
    isError: loginMutation.isError,
  };
};
